export const Occupation = {
    path: '/occupations',
    name: 'occupations',
    component: () => import('@/views/Occupation/OccupationPage.vue'),
    children: [
        {
            path: '/occupations/add',
            name: 'occupations.add',
            component: () => import('@/views/Occupation/Form/OccupationForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/occupations/edit/:id',
            name: 'occupations.edit',
            component: () => import('@/views/Occupation/Form/OccupationForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/occupations/duplicate/:id',
            name: 'occupations.duplicate',
            component: () => import('@/views/Occupation/Form/OccupationForm.vue'),
            props: {duplicateAction: true}
        },
        {
            path: '/occupations/import_pay_sections/:id',
            name: 'occupations.import_pay_sections',
            component: () => import('@/views/Occupation/Form/ImportOccupationPaySections.vue'),
        },
        {
            path: '/occupations/delete/:id',
            name: 'occupations.delete',
            component: () => import('@/views/Occupation/Form/OccupationForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/occupations/view/:id',
            name: 'occupations.view',
            component: () => import('@/views/Occupation/Form/OccupationForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/occupations/add_pay_section_to_multiple/',
            name: 'occupations.add_pay_section_to_multiple',
            component: () => import('../views/Occupation/Form/AddPaySectionToMultipleOccupation.vue'),
            props: {addAction: true}
        },
        {
            path: '/occupations/remove_pay_section_from_multiple/',
            name: 'occupations.remove_pay_section_from_multiple',
            component: () => import('../views/Occupation/Form/AddPaySectionToMultipleOccupation.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/occupations/set_pay_section_to_workers',
            name: 'occupations.set_pay_section_to_workers',
            component: () => import('../views/Occupation/Form/SetPaySectionsToWorkers.vue'),
        },
    ]
}